export default {
  'dept.edit.update.title': '修改部门',
  'dept.edit.add.title': '新增部门',
  'dept.edit.update.success': '修改成功',
  'dept.edit.add.success': '新增成功',
  'dept.edit.form.parentId': '上级部门',
  'dept.edit.form.parentId.placeholder': '请选择上级部门',
  'dept.edit.form.deptName': '部门名称',
  'dept.edit.form.deptName.placeholder': '请输入部门名称',
  'dept.edit.form.deptName.required': '请输入部门名称',
  'dept.edit.form.status': '部门状态',
  'dept.edit.form.status.normal': '正常',
  'dept.edit.form.status.disabled': '停用',
  'dept.edit.form.status.required': '请选择部门状态',
  'dept.edit.form.sortNum': '排序',
  'dept.page.query.form.deptName': '部门名称',
  'dept.page.query.form.deptName.placeholder': '请输入部门名称',
  'dept.page.query.expandAll': '展开全部',
  'dept.page.query.collapseAll': '收起全部',
  'dept.page.query.add': '添加部门',
  'dept.page.column.deptName': '部门名称',
  'dept.page.column.status': '状态',
  'dept.page.column.status.normal': '正常',
  'dept.page.column.status.disabled': '禁用',
  'dept.page.column.sortNum': '排序',
  'dept.page.column.operation': '操作',
  'dept.page.delete.confirm.message': '确定要删除"{deptName}"以及它下面的所有部门吗？',
  'dept.page.delete.success': '删除成功',
}
